import React, { ChangeEvent, useEffect, useState } from 'react'
import { Autocomplete, Chip, createFilterOptions, TextField, Theme } from '@mui/material'

import { makeStyles } from '@mui/styles'
import { Tag } from '../types'

interface ISelectTagComponentData {
  options: Tag[]
  id?: string
  name?: string
  margin?: 'normal' | 'dense' | 'none'
  label: string
  value?: Tag[]
  required?: boolean
  defaultValue?: any
  onChange?: (value: Tag[]) => void
  disableClearable?: boolean
  disabled?: boolean
  placeholder?: string
  limitTags?: number | undefined
  size?: 'medium' | 'small' | undefined
  helperText?: string
  error?: boolean
  variant?: 'outlined' | 'filled' | 'standard'
  fullWidth?: boolean
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    minWidth: '200px',
  },
}))
const TagComponent: React.FC<ISelectTagComponentData> = (props) => {
  const classes = useStyles()

  const [value, setValue] = useState<Tag[]>(props.value || [])
  const [selectActive, setSelectActive] = useState<boolean>(false)

  useEffect(() => {
    props.value && setValue(props.value)
  }, [props.value],
  )
  const filter = createFilterOptions<Tag>()

  const checkTags = (tags: Tag[]) => {
    const cleanedTags: Tag[] = []
    tags.forEach((tag: Tag) => {
      if (typeof tag !== 'string') {
        if (!(tag.id && (tag.id).includes('newTag_')) || !tag.id) {
          if (!cleanedTags.find((elem: Tag) => elem.label === tag.label)) {
            cleanedTags.push(tag)
          }
        } else {
          const tagLabel = tag.id.replace('newTag_', '').replace('"', '')
          if (!cleanedTags.find((elem: Tag) => elem.label === tag.label)) {
            cleanedTags.push({ label: tagLabel })
          }
        }
      }
    })
    return cleanedTags
  }

  return (
    <Autocomplete
      multiple
      value={value}
      id={props.id}
      selectOnFocus
      clearOnBlur
      className={classes.root}
      disableClearable={props.disableClearable ? props.disableClearable : false}
      disabled={props.disabled ? props.disabled : false}
      fullWidth={props.fullWidth}
      size={props.size}
      limitTags={props.limitTags}
      options={props.options}
      defaultValue={props.defaultValue}
      freeSolo
      handleHomeEndKeys
      onChange={(event: ChangeEvent<any>, elem: any) => {
        setValue(checkTags(elem))
        props.onChange && props.onChange(checkTags(elem))
      }}
      filterOptions={(options: Tag[], params) => {
        const filtered = filter(options, params)
        const { inputValue } = params
        // Suggest the creation of a new value
        const isExisting = options.some((option) => inputValue === option.label)
        if (inputValue !== '' && !isExisting) {
          filtered.push({
            id: `newTag_${inputValue}`,
            label: `"${inputValue}" hinzufügen`,
          })
        }
        return filtered
      }}
      renderTags={(value: readonly Tag[], getTagProps) =>
        value.map((option: Tag, index: number) => {
          let tagLabel = option.label
          if (option.id && (option.id).includes('newTag_')) {
            tagLabel = option.id.replace('newTag_', '').replace('"', '')
          }
          return (
            <div key={index}>
              <Chip variant='filled' label={tagLabel} {...getTagProps({ index })} />
            </div>
          )
        })}
      renderInput={(params) => (
        <TextField
          {...params}
          label={props.label}
          name={props.name}
          placeholder={props.placeholder}
          required={props.required}
          helperText={props.helperText}
          error={props.error}
          InputLabelProps={{
            shrink: true,
          }}
          variant={props.variant}
          margin={props.margin}
          onKeyDown={(event) => {
            if (event.code === 'ArrowDown' || event.code === 'ArrowUp') {
              setSelectActive(true)
            }
            if (event.code === 'Enter' && selectActive) {
              setSelectActive(false)
            }
            if (event.code === 'Enter' && event.target && !selectActive) {
              const target = event.target as HTMLInputElement
              const newValues = value
              const equalToExistingTag = props.options.find((Tag) => Tag.label.toLowerCase() === target.value.toLowerCase())
              if (equalToExistingTag) {
                newValues.push(equalToExistingTag)
              } else {
                newValues.push({
                  label: target.value,
                })
              }
              setValue(newValues)
            }
          }}
        />
      )}
    />
  )
}
export default TagComponent
